import React, { useState } from "react";
import "./SapAbap.css";
import DownloadForm from "../DownloadForm/DownloadForm";

const SapPM = () => {
  const [showForm, setShowForm] = useState(false);

  const handleDownloadClick = () => {
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  return (
    <div className="sapfincon-wrapper">
      {/* Animated Background Circles */}
      <div className="background-animation">
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
      </div>

      {/* Header Section */}
      <div
        className="jumbotron jumbotron-fluid page-header position-relative overlay-bottom"
        style={{ marginBottom: "90px" }}
      >
        <div className="container text-center py-5" style={{ marginTop: "-80px" }}>
          <h1 className="text-white display-1">Plant Maintenance</h1>
          <div className="d-inline-flex text-white mb-5">
            <p className="m-0 text-uppercase">
              <a className="text-white" href="">Home</a>
            </p>
            <i className="fa fa-angle-double-right pt-1 px-3"></i>
            <p className="m-0 text-uppercase">SAP</p>
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="sapfincon-flexbox">
        <div className="sapfincon-left">
          <div className="sapfincon-wrapper zoom-effect">
            <img
              src="/assets/img/sapfince.jpg"
              alt="SAP Banner"
              className="sapfincon-main-image"
            />
          </div>
        </div>
        <div className="sapfincon-right">
          <h2 className="sapfincon-title">Drive Operational Excellence with BDM Technology’s Industry-Driven SAP PM Course</h2>
          <p className="sapfincon-description">
            SAP PM is the key module for managing an organization’s maintenance activities efficiently. From preventive maintenance to breakdown repair and performance analytics, SAP PM helps ensure the reliability and longevity of plant assets.
          </p>
          <ul className="sapfincon-list">
            {[
              "Preventive and breakdown maintenance of machinery and equipment",
              "Inspection planning, scheduling, and execution",
              "End-to-end plant maintenance from work orders to completion",
              "Integration with MM, FICO, and Production Planning modules",
              "Asset performance and failure tracking analytics",
              "Supports digital transformation through IoT and KPIs",
            ].map((text, idx) => (
              <li className="sapfincon-list-item" key={idx}>
                <span className="sapfincon-icon">
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 512 512"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998
                       26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997
                       26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206
                       0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"/>
                  </svg>
                </span>
                <span className="sapfincon-text">{text}</span>
              </li>
            ))}
          </ul>
          <p className="sapfincon-careers">Maintenance Engineer, SAP PM Consultant, Reliability Analyst</p>
        </div>
      </div>

      {/* Course Upgrade Section */}
      <div className="sapfincon-content-section">
        <div className="container">
          <div className="upgrade-section">
            <h2 className="section-title">
              <strong>Upgrade your operational skills with BDM Technology’s SAP PM Program!</strong>
            </h2>
            <p className="section-description">
              SAP PM is essential for industries with physical assets such as machinery, equipment, and infrastructure. It supports end-to-end plant maintenance operations including inspection, servicing, and repair, making it crucial for asset-intensive businesses.
            </p>
          </div>

          {/* Why Study */}
          <div className="why-study-section">
            <h3 className="subsection-title"><strong>Why Study SAP Plant Maintenance (PM)?</strong></h3>
            <p className="subsection-description">
              SAP PM is essential for industries like manufacturing, energy, utilities, and logistics. It enables efficient maintenance practices, reduced downtime, and prolonged asset life.
            </p>
          </div>

          {/* Benefits */}
          <div className="benefits-section">
            <h3 className="subsection-title"><strong>Benefits of Learning SAP PM</strong></h3>
            <ul className="benefits-list">
              <li><strong>High Demand in Manufacturing & Utilities</strong> – Critical for equipment-intensive industries.</li>
              <li><strong>Automated Maintenance Scheduling</strong> – Improves uptime and reduces operational disruptions.</li>
              <li><strong>Integrated with Core ERP Modules</strong> – Works with SAP MM, FICO, and PP.</li>
              <li><strong>Asset Lifecycle Management</strong> – Enables efficient tracking from installation to disposal.</li>
              <li><strong>Cost & Downtime Reduction</strong> – Minimizes equipment failure and unplanned repairs.</li>
              <li><strong>Global Job Market</strong> – Required by multinational firms, EPCs, and service companies.</li>
              <li><strong>Digital Maintenance Reporting</strong> – Real-time visibility into maintenance KPIs.</li>
            </ul>
          </div>

          {/* Future Scope */}
          <div className="future-scope-section">
            <h3 className="subsection-title"><strong>Future Scope of SAP PM</strong></h3>
            <ul className="scope-list">
              <li><strong>Smart Maintenance Integration</strong> – With IoT and Industry 4.0 adoption.</li>
              <li><strong>Mobile Maintenance Execution</strong> – Field operations enabled on tablets/phones.</li>
              <li><strong>Predictive Maintenance</strong> – Using machine learning for early failure detection.</li>
              <li><strong>Global SAP PM Consulting</strong> – Freelance and full-time roles worldwide.</li>
              <li><strong>Cross-Functional Skills</strong> – Integrate with MM, PP, and FICO for career growth.</li>
            </ul>
          </div>

          {/* Key Features */}
          <div className="key-features-section">
            <h3 className="subsection-title">
              <strong>Key Features of BDM Technology</strong>
            </h3>
            <div className="features-grid">
              <div className="feature-item">
                <h4>100% Job-Oriented Training</h4>
                <p>Curriculum tailored to industry requirements, ensuring you gain the skills employers are looking for.</p>
              </div>
              <div className="feature-item">
                <h4>Industry Expert Faculties</h4>
                <p>Learn from seasoned professionals with real-world experience.</p>
              </div>
              <div className="feature-item">
                <h4>Flexible Demo Class Available</h4>
                <p>Opportunity to attend a demo session and experience the training style before enrolling.</p>
              </div>
              <div className="feature-item">
                <h4>Completed 400+ Batches</h4>
                <p>Proven track record with hundreds of successful batches, demonstrating program reliability and effectiveness.</p>
              </div>
              <div className="feature-item">
                <h4>Certification Guidance</h4>
                <p>Support throughout your journey to help you earn relevant certifications that boost your career.</p>
              </div>
              <div className="feature-item">
                <h4>Live Practical Sessions</h4>
                <p>Hands-on, interactive sessions to reinforce learning and apply concepts in real-time.</p>
              </div>
              <div className="feature-item">
                <h4>Peaceful Environment</h4>
                <p>A conducive learning atmosphere that helps you focus and maximize your learning potential.</p>
              </div>
            </div>
          </div>

          {/* Who Should Attend */}
          <div className="who-attend-section">
            <h3 className="subsection-title"><strong>Who Should Enroll</strong></h3>
            <ul className="attend-list">
              <li>Mechanical, Electrical, and Maintenance Engineers</li>
              <li>Professionals in plant, utility, or production operations</li>
              <li>ERP Consultants looking to specialize in SAP PM</li>
              <li>Freshers interested in core industry-based ERP careers</li>
            </ul>
          </div>

          {/* Hiring Companies */}
          <div className="hiring-companies-section">
            <h3 className="subsection-title"><strong>Hiring Companies</strong></h3>
            <div className="companies-grid">
              {[{ logo: "/assets/img/Cognizant.png" },{ logo: "/assets/img/tcs.jpg" },{ logo: "/assets/img/infoysis.jpg" },{ logo: "/assets/img/ibm.png" },{ logo: "/assets/img/hcl.png" },{ logo: "/assets/img/Accenture.png" },{ logo: "/assets/img/capgemini.png" },{ logo: "/assets/img/Deloitte.png" },{ logo: "/assets/img/nttdata.png" },{ logo: "/assets/img/wipro.png" },{ logo: "/assets/img/KaarTech.png" },{ logo: "/assets/img/lt.png" },{ logo: "/assets/img/Siemens.png" },{ logo: "/assets/img/techmahindra.png" }].map((company, index) => (
                <div className="company-card" key={index}>
                  <img src={company.logo} alt={company.name} className="company-logo" />
                  <span className="company-name">{company.name}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Salary Overview */}
          <div className="salary-overview-section">
            <h3 className="subsection-title"><strong>Salary Overview</strong></h3>
            <div className="salary-grid">
              <div className="salary-item">
                <h4>Entry-Level (0-2 Years)</h4>
                <p className="salary-amount">₹4.5 – ₹7.5 LPA</p>
              </div>
              <div className="salary-item">
                <h4>Mid-Level (2-5 Years)</h4>
                <p className="salary-amount">₹7.5 – ₹13 LPA</p>
              </div>
              <div className="salary-item">
                <h4>Senior-Level (5+ Years)</h4>
                <p className="salary-amount">₹13 – ₹20+ LPA</p>
              </div>
              <div className="salary-item">
                <h4>SAP PM Architects & Maintenance Leads</h4>
                <p className="salary-amount">₹22 – ₹30+ LPA</p>
              </div>
            </div>
          </div>

          {/* Download PDF */}
          <div className="download-section">
            <h3 className="download-heading">
              Want to know more? <br />
              <span>Please download the course PDF.</span>
            </h3>
            <button className="download-button" onClick={handleDownloadClick}>
              📄 Download Course PDF
            </button>
          </div>

          {showForm && (
            <DownloadForm
              onClose={handleCloseForm}
              courseName="SAP PM"
              pdfUrl="/uploads/pdfs/sap-pm.pdf"
            />
          )}
        </div>
      </div>
   


      
    </div>
  );
};

export default SapPM;